module.exports = __webpack_public_path__ + "img/2.387ed30d.jpg";